import React from 'react';

const ButtonTransparent = ({ label, Icon, isSelected, onClick, iconPosition = 'right', className = '' }) => {
  return (
    <button
      onClick={onClick}
      className={`flex items-center justify-center gap-2 px-4 py-3 rounded-xl border border-white w-full md:w-fit ${className}`}
      style={{
        borderRadius: '12px',
        gap: '8px'
      }}
    >
      {iconPosition === 'left' && Icon && <Icon className="w-5 h-5 text-white" />}
      <span className="text-white text-sm">{label}</span>
      {iconPosition === 'right' && Icon && <Icon className="w-5 h-5 text-white" />}
    </button>
  );
};

export default ButtonTransparent;
